import { useState, useEffect, useCallback, Fragment } from 'react';
import { Row, Col, Tag, Empty, Spin } from 'antd';
import { admissionService } from '../../../services/admission';
import { useTranslation } from 'react-i18next';

const SummaryServices = ({ id }) => {
  const [admissionServices, setAdmissionServices] = useState();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const fetchAdmissionServices = useCallback(async () => {
    setLoading(loading => { return { ...loading, services: true } });
    const response = await admissionService.getAdmissionServices({ reservationId: id });
    setAdmissionServices(response);
    setLoading(loading => { return { ...loading, services: false } });
  }, [id]);

  useEffect(() => {
    fetchAdmissionServices();
  }, [fetchAdmissionServices]);

  if (loading.services) {
    return (
      <Spin className='custom-spinner margin-top' />
    );
  }

  return (
    <Fragment>
      {
        admissionServices && admissionServices.length > 0 ?
          <Row>
            <Col lg={24} xs={24} className="admission-details__services">
              <Row>
                <Col lg={24} xs={24}>
                  <Row>
                    <h2 className="mb-20">
                      {t('admissionPage.summaryServices.services')}
                    </h2>
                  </Row>
                  <Row>
                    <Col lg={14} xs={14}>
                      <p className="title ml-15 mb-5">
                        {t('admissionPage.summaryServices.service')}
                      </p>
                    </Col>
                    <Col lg={10} xs={10}>
                      <p className="text-center title mr-15 mb-5">Ingresados</p>
                    </Col>
                  </Row>
                  {
                    admissionServices.map((item, index) => {
                      return (
                        <Row key={index} className="row-item p-15 mb-10">
                          <Col lg={14} xs={14}>
                            <p className="mb-0">{item.service_name} ({item.blocks})</p>
                          </Col>
                          <Col lg={10} xs={10} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Tag>
                              <Row>
                                <Col>
                                  <p className='bold-text mb-0'>{item.admitted_patients}</p>
                                </Col>
                                <Col>
                                  <p className='ml-15 mr-15 mb-0'>de</p>
                                </Col>
                                <Col>
                                  <p className='mb-0'>{item.total_patients}</p>
                                </Col>
                              </Row>
                            </Tag>
                          </Col>
                        </Row>
                      )
                    })
                  }
                </Col>
              </Row>
            </Col>
          </Row> : (
            <Row>
              <Col lg={22} xs={22}>
                <h2>{t('admissionPage.summaryServices.services')}</h2>
                <Empty
                  description={
                    <span style={{ fontSize: 12 }}>
                      {t('admissionPage.summaryServices.nonPerformedServices')}
                    </span>
                  }
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                />
              </Col>
            </Row>
          )
      }
    </Fragment>
  )
}

export default SummaryServices;